import React, { Component } from 'react';

class Limites extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        let data = this.props.data;
        const { children } = this.props;
      
        return (
            <div className="row top-separator-xs">
                <div className="col-xs-12">
                    <div className="row bottom-separator">
                        <div className="col-xs-12">
                            <h2>
                                Límites
                            </h2>
                        </div>
                    </div>

                    {children}

                </div>
            </div>
        );
    }
};

export default Limites;